import * as types from "../types";

const state = {
  transferToMarket: {}
};

const getters = {
  [types.transfer.getters.GET_TRANSFER_TO_MARKET]: state => {
    return state.transferToMarket;
  }
};

const mutations = {
  [types.transfer.mutations.MUTATE_TRANSFER_TO_MARKET]: (state, payload) => {
    state.transferToMarket = payload;
  }
};

const actions = {
  [types.transfer.actions.ACTION_TRANSFER_TO_MARKET]: ({ commit }, payload) => {
    commit(types.transfer.mutations.MUTATE_TRANSFER_TO_MARKET, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
